import React, {useCallback, useEffect, useMemo, useState} from "react";
import styles from "./PatientCondition.module.scss";
import { SaveIcon, DashexaminationIcon} from "../../assets";
import {Autocomplete, Input} from "../../ui-components";
import {
  brigadeTypes, brigadeTypesForDp, RequestReasonTypes,
  SeverityConditionTypes
} from "../../services/constants";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {omit} from "lodash";
import {updateCustomerInfoRequests} from "../requests/er-thunk";
import {getDiagnosesList} from "../../app/app-slice";
import {Spinner} from "../../shared";
import {debounce} from 'lodash'

const PatientCondition = ({isEditable}) => {

  const {
    request,
    pool,
    activePanel,
    er_call,
    insurance_org,
    emergency_responsible
  } = useAppSelector(state => state.requests)
  const {diagnoses} = useAppSelector(state => state.app)
  const [loader, setLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()
  const diagnosesList = useMemo(() => {
    return  diagnoses.map((el) => {
      return {value: el.title, title: el.title}
    })
  }, [diagnoses])

  const [updateData, setUpdateData] = useState({

    request_reason: request?.data?.request_reason,
    severity: request?.data.severity,
    weight: request?.data.weight,
    additional: request?.data.additional,
    diagnose: request?.data.diagnose,
    brigade_type: request?.data.brigade_type,

  })

  useEffect(() => {
    dispatch(getDiagnosesList(request?.data?.diagnose || ""))
    setUpdateData({
      request_reason: request?.data?.request_reason,
      severity: request?.data.severity,
      weight: request?.data.weight,
      additional: request?.data.additional,
      diagnose: request?.data.diagnose,
      brigade_type: request?.data.brigade_type,

    })
  }, [request])
  const isValid = (data) => {
    const dataWithoutFoodAndWC = { ...data };
    delete dataWithoutFoodAndWC.severity;
    delete dataWithoutFoodAndWC.diagnose;
    delete dataWithoutFoodAndWC.weight;
    delete dataWithoutFoodAndWC.additional;
    return Object.keys(dataWithoutFoodAndWC).every((k) => {
      return data[k]
    })
  }
  const handleUpdate = useCallback( () => {
    if (isValid(omit(updateData, ['comment1']))) {
      setLoader(true);
      dispatch(updateCustomerInfoRequests({uuid: request?.uuid, data: {data: updateData}})).then(res => {
        // @ts-ignore
        if(res) {
          setTimeout(() => {
            setLoader(false);
            // setAcceptSuccess(true);
          }, 1000); // Delay of 100ms
        }
      })
    } else {
      // setErrorMessage('*Заполните все поля.')
    }
  }, [dispatch, request?.uuid, updateData])

  const debouncedChangeHandler = useMemo(
    () => debounce((query) => {
      setLoading(true)
      dispatch(getDiagnosesList(query))
        .then(res => setLoading(false))
    }, 1000),
    [dispatch]
  );


  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <DashexaminationIcon className='mr-5'/>
        <p className={styles.title}>Состояние больного</p>
        <div className={styles.title} >{request?.sentry_type}</div>
        {!isEditable && (
          loader ? (
            <Spinner/>
          ) : (
            <SaveIcon style={{ cursor: "pointer" }} onClick={handleUpdate} />
          )
        )}
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.bodyHeadWrapper} >
        <Autocomplete
          options={RequestReasonTypes}
          className={styles.input}
          onChange={(val) => setUpdateData({...updateData, request_reason: val.value})}
          optionLabel={'value'}
          optionValue={'value'}
          disabled={isEditable}
          value={updateData.request_reason}
          label="Повод обращения"/>
        <Autocomplete
          options={SeverityConditionTypes}
          className={styles.input}
          onChange={(val) => setUpdateData({...updateData, severity: val.value})}
          optionLabel={'value'}
          optionValue={'value'}
          disabled={isEditable}
          value={updateData.severity}
          label="Тяжесть состояния"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Autocomplete
          options={brigadeTypes}
          className={styles.input}
          onChange={(val) => setUpdateData({...updateData, brigade_type: val.value})}
          optionLabel={'value'}
          optionValue={'value'}
          disabled={isEditable}
          value={updateData.brigade_type}
          label="Профиль бригады"/>
        <Autocomplete
          options={diagnosesList}
          isLoading={loading}
          className={styles.input}
          onChange={(val) => setUpdateData({...updateData, diagnose: val.value})}
          optionLabel={'value'}
          optionValue={'value'}
          disabled={isEditable}
          value={updateData.diagnose}
          onInputChange={(value) => value && debouncedChangeHandler(value)}
          label="Диагноз"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='weight'
               onChange={(e) => setUpdateData({...updateData, weight: e?.target?.value})}
               value={updateData.weight}
               // error={!updateData.weight}
               className={styles.input}
               disabled={isEditable}
               label="Вес больного (кг)"/>
        <Input name='additional'
               onChange={(e) => setUpdateData({...updateData, additional: e?.target?.value})}
               value={updateData.additional}
               // error={!updateData.additional}
               className={styles.input}
               disabled={isEditable}
               label="Дополнительная информация"/>
      </div>

    </div>
  </div>
}

export default PatientCondition
